import { UserProfileModel } from 'lib/ng2-sapmp/src/models/userprofile/user-profile.model';

import { AddUserModel } from './add-user.model';
import { Component, OnInit, OnDestroy } from '@angular/core';
import { map, catchError } from 'rxjs/operators';
import { Router } from '@angular/router';
import { AuthenticationService, ValidationService, UtilityService, AdobeAnalyticsService } from 'lib/ng2-sapmp/src/providers';
import { AddUserService } from './add-user.service';
import { BreadCrumbModel, BreadCrumbService } from 'lib/ng2-sapmp/src/ui-components/breadcrumb';
import { BREADCRUMBS, PIVOTS } from 'config';
import { PageLoaderService } from 'lib/ng2-sapmp/src/ui-components/page-loader';
import { FormConfigurationModel, FormPropertyModel } from 'lib/ng2-sapmp/src/ui-components/form-builder';
import { FormBuilderService } from 'lib/ng2-sapmp/src/ui-components/form-builder/form-builder.service';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { MobilePivotModel } from 'lib/ng2-sapmp/src/ui-components/mobile-pivot/mobile-pivot.model';

declare var logoutCurrentUser
@Component({
    providers: [ValidationService, AddUserService, FormBuilderService],
    templateUrl: './add-user.component.html',
    styleUrls: ['./add-user.component.scss']
})
export class AddUserComponent implements OnInit {
    addUserModel: AddUserModel;
    addUser: FormGroup;
    errorMsg = '';
    breadCrumbs: BreadCrumbModel[];
    previousRoute: any;
    user: UserProfileModel;
    pivots: Array<MobilePivotModel>;
    csrPermissionAddUserButton: boolean;
    formErrors = {
        'firstName': '',
        'lastName': '',
        'phoneNumber': '',
        'email': ''
    };

    validationMessages = {
        'firstName': {
            'required': 'First name is required.',
            'pattern': 'Please enter a valid first name.'
        },
        'lastName': {
            'required': 'Last name is required.',
            'pattern': 'Please enter a valid last name.'
        },
        'phoneNumber': {
            'required': 'Contact number is required.',
            'checkPattern': 'Please enter a valid 10 digit contact number (XXXXXXXXXX).',
        },
        'email': {
            'required': 'Email is required.',
            'pattern': 'Please enter a valid email.',
        }
    };

    constructor(private formBuilder: FormBuilder,
        private validationService: ValidationService,
        private router: Router,
        private utilityService: UtilityService,
        private addUserService: AddUserService,
        private pageloaderService: PageLoaderService,
        private authenticationService: AuthenticationService,
        private breadCrumbService: BreadCrumbService,
        private adobeAnalyticsService: AdobeAnalyticsService) {

        this.csrPermissionAddUserButton = this.utilityService.checkFieldPermission('adduser.addUser',
            JSON.parse(sessionStorage.getItem('permissions')).perm);
        this.addUserModel = new AddUserModel();
        this.pivots = new Array<MobilePivotModel>();
    }

    ngOnInit() {
        document.title = this.utilityService.getPageTitleConfig()[this.router.routerState.snapshot.url];
        this.authenticationService.setLoginSuccessUrl(this.router.routerState.snapshot.url);
        this.user = this.authenticationService.getUser();
        this.previousRoute = this.breadCrumbService.getLastUrlFromBreadCrumb();
        if (this.previousRoute && this.previousRoute.label !== 'Console dashboard') {
            this.pivots.push({ label: 'Single Product Page', routerLink: '/manageProduct' });
        }
        this.pivots.push({ label: 'Console dashboard', routerLink: '/dashboard' });
        if (this.breadCrumbService.getBreadCrumbs() === undefined) {
            this.breadCrumbService.setStaticBreadCrumbs(this.router.routerState.snapshot.url);
        }
        this.breadCrumbService.setCurrentBreadCrumb({ label: 'Add a user', routerLink: this.router.url });
        this.buildForm();
        this.addUserService.createPageLoadProperties(this.router.url, 'Add User page', 'BC Add User Pg');
    }

    buildForm(): void {
        this.addUser = this.formBuilder.group({
            'firstName': ['', [Validators.required, Validators.pattern(/(?!^\s+$)^.+$/)]],
            'lastName': ['', [Validators.required, Validators.pattern(/(?!^\s+$)^.+$/)]],
            'phoneNumber': ['', [Validators.required, this.utilityService.validatePhoneNumber]],
            'email': ['', [Validators.required,
            Validators.pattern('^[_A-Za-z0-9-\\+]+(\\.[_A-Za-z0-9-]+)*@[A-Za-z0-9-]+(\\.[A-Za-z0-9]+)*(\\.[A-Za-z]{2,})$')]]
        });
        this.validationService.validate(
            this.addUser,
            this.formErrors,
            this.validationMessages
        );
    }

    cancel() {
        // this.router.navigate([this.previousRoute.routerLink]);
        const parentUrl = this.utilityService.getParentUrl();
        this.router.navigate([parentUrl]);
    }

    contactChange(event) {
        event = Object(event);
        if (event) {
            if (event.keyCode === 46) {
                // not to except .
                event.preventDefault();
            }
        }
    }

    contactBlur(event) {
        if (event.target.value.match('^[0-9]{1,100}$')) {
            const val = this.utilityService.onBlurFormat(event.target.value, 'dot');
            this.addUser.get('phoneNumber').setValue(val);
        }
        // this.utilityService.validatePhoneNumber
    }

    contactFocus(event) {
        const val = this.utilityService.onFocusFormat(event.target.value, 'dot');
        this.addUser.get('phoneNumber').setValue(val);
    }

    submit(): void {
        this.pageloaderService.setPageLoaderStatus(false);
        this.addUserModel.firstName = this.addUser.value.firstName;
        this.addUserModel.lastName = this.addUser.value.lastName;
        this.addUserModel.email = this.addUser.value.email;
        this.addUserModel.phoneNumber = this.addUser.value.phoneNumber;
        this.addUserService.saveUserDetails(this.utilityService.getEnvConfig().addUserUrl, this.addUserModel, this.user.companyId)
            .subscribe(response => {
                const userDetail = { firstName: '', lastName: '', email: '', contactNumber: '' };
                userDetail.firstName = this.addUser.value.firstName;
                userDetail.lastName = this.addUser.value.lastName;
                userDetail.email = this.addUser.value.email;
                userDetail.contactNumber = this.addUser.value.phoneNumber;
                sessionStorage.setItem('user-manage' + response.clientId, JSON.stringify(userDetail));
                this.pageloaderService.setPageLoaderStatus(true);
                this.router.navigate(['/user/summary/' + response.clientId]);
            }, error => {
                this.pageloaderService.setPageLoaderStatus(true);
                this.handleError(error);
            });
    }

    handleError = (err) => {
        let isBusinessRuleError = false;
        if (err) {
            if (err.status === 500) {
                // this.errorMsg = this.addUserModel.firstName + ' ' + this.addUserModel.lastName + ' is already in the system';
                this.errorMsg = 'We couldn\'t complete your request. Please try again later. ';
                isBusinessRuleError = true;
            } else if (err.status === 401) {
                this.errorMsg = 'Session expired, Please login again.';
                logoutCurrentUser(true);
            } else if (err.status === 400) {
                this.errorMsg = 'Email is already in the system.';
                isBusinessRuleError = true;
            } else {
                this.errorMsg = 'We couldn\'t complete your request. Please try again later. ';
            }
            this.utilityService.loadFocusOnTop();
        }
        if (isBusinessRuleError) {
            this.adobeAnalyticsService.CreateSeriveAlertProperties(err.status, err.statusText, 'formResponse', 'Failure_BusinessRule');
        } else {
            this.adobeAnalyticsService.CreateSeriveAlertProperties(err.status, err.statusText, 'formResponse');
        }
    }
}

